<!-- #1182 lot 1 — non masquable : un bandeau qu'on ferme est un bandeau qu'on
     ne revoit pas, et l'onglet reste périmé pour le reste de sa vie. -->
<div class="stale-banner" *ngIf="stale" role="status" aria-live="polite">
  <i class="fas fa-arrows-rotate stale-banner__icon" aria-hidden="true"></i>

  <div class="stale-banner__text">
    <strong>{{ translate.instant('BUNDLE_STALE.TITLE') }}</strong>
    <span>{{ operatorMessage || translate.instant('BUNDLE_STALE.MESSAGE') }}</span>
  </div>

  <button type="button" class="stale-banner__action" (click)="reload()">
    {{ translate.instant('BUNDLE_STALE.RELOAD') }}
  </button>
</div>
